// src/firebaseConfig.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions"; // <--- ADDED

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAY5xQdwpcRhPatX_EmBRBQIqyrMf15lQY",
  authDomain: "author-site-a0977.firebaseapp.com",
  projectId: "author-site-a0977",
  storageBucket: "author-site-a0977.firebasestorage.app",
  messagingSenderId: "540672677481",
  appId: "1:540672677481:web:89f0e7fe617dccd084f4f8",
  measurementId: "G-Z561L11PR8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Functions service
// NOTE: Use the region where you deployed your function (us-central1 is standard)
const functions = getFunctions(app, 'us-central1'); // <--- ADDED

// Export the functions instance so WalterPyneWebsite.jsx can import it
export { functions }; // <--- ADDED AND EXPORTED